import { apiErrorWrapper } from '@/api/common/apiErrorWrapper.ts'
import { client } from '@/api/common/client.ts'
import { apiErrorMapper } from '@/api/common/utils/apiErrorMapper.ts'

type DeleteMappingProps<TRequest> = {
  path: string
  body: TRequest
}

export async function deleteMapping<TResponse, TRequest>({
  path,
  body,
}: DeleteMappingProps<TRequest>) {
  const { data, error } = await apiErrorWrapper(
    async () => await client.delete(path, {
      data: body,
    }),
  )
  if (error) {
    apiErrorMapper(error)
  }
  return data as TResponse
}
